import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NodataComponent } from './nodata/nodata.component';


@NgModule({
  declarations : [
    NodataComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
     
  ],
  exports : [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NodataComponent
  ]
})
export class LayoutModule { }
